import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import useMobileLayout from 'Hooks/useMobileLayout';
import TableHeadItem from './TableHeadItem';
import TableRowItem from './TableRowItem';
import NoDataPlaceholderMessage from './NoDataPlaceholderMessage';

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    marginBottom: theme.spacing(2),
  },
  table: {
    width: '100%',
    '& td:last-child': {
      textAlign: 'right',
    },
  },
  tableMobile: {
    '& td': {
      display: 'flex',
    },
    '& td:last-child': {
      textAlign: 'left',
    },
  },
  thead: {
    borderBottom: `1.5px solid ${theme.palette.grey[200]}`,
  },
  theadMobile: {
    display: 'none',
  },
  tableTitle: {
    padding: theme.spacing(1, 0),
    marginBottom: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
  },
});

const Table = ({
  columns,
  data,
  className,
  classes,
  title,
  test,
  PlaceholderMessageProps,
  RowItemProps,
  forceUseMobileLayout,
  ...rest
}) => {
  let isMobile = useMobileLayout();
  isMobile = forceUseMobileLayout || isMobile;

  const hasTableData = (data && data.length >= 1 && columns);
  return (
    <div
      className={classNames(classes.root, className)}
      test={test}
    >
      {title && (
        <Typography
          className={classes.tableTitle}
          variant={'h4'}
          color={'primary'}
          weight={'bold'}
        >
          {title}
        </Typography>)
      }
      {hasTableData ? (
        <table
          className={classNames(classes.table, className, {
            [classes.tableMobile]: isMobile,
          })}
        >
          <thead
            className={classNames(classes.thead, {
              [classes.theadMobile]: isMobile,
            })}
          >
            <tr>
              {columns.map((h) => {
                return <TableHeadItem key={h.key} item={h} />;
              })}
            </tr>
          </thead>
          <tbody>
            {data.map((item) => {
              return (
                <TableRowItem
                  key={item.id}
                  data={item}
                  columns={columns}
                  {...rest}
                  {...RowItemProps}
                  forceUseMobileLayout={forceUseMobileLayout}
                />);
            })}
          </tbody>
        </table>
      ) : <NoDataPlaceholderMessage {...PlaceholderMessageProps} />
      }
    </div>
  );
};

Table.defaultProps = {
  className: '',
  columns: null,
  data: null,
  title: null,
  test: 'table-view-root',
  PlaceholderMessageProps: {},
  forceUseMobileLayout: false,
};

Table.propTypes = {
  columns: PropTypes.array,
  data: PropTypes.array,
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  title: PropTypes.string,
  test: PropTypes.string,
  PlaceholderMessageProps: PropTypes.object,
  forceUseMobileLayout: PropTypes.bool,
};

export default withStyles(styles)(Table);
